/** @param {unknown} st */
export function normalizeOrderStatus(st) {
  const s = String(st || "").trim().toLowerCase();
  if (s === "processing") return "preparing";
  if (s === "completed") return "delivered";
  if (s === "canceled") return "cancelled";
  return s;
}

/** هل الطلب ملغى (إلغاء إداري — لا يُحذف من قاعدة البيانات)؟ */
export function orderIsCancelled(st) {
  return normalizeOrderStatus(st) === "cancelled";
}

/** أنماط الشارات في لوحة الطلبات */
export function orderStatusBadgeVariant(st) {
  const k = normalizeOrderStatus(st);
  if (k === "new") return "new";
  if (k === "preparing") return "preparing";
  if (k === "shipped") return "shipped";
  if (k === "delivered") return "delivered";
  if (k === "cancelled") return "cancelled";
  return "new";
}

/**
 * @param {unknown} st
 * @param {"ar"|"en"} lang
 */
export function orderStatusLabel(st, lang = "ar") {
  const k = normalizeOrderStatus(st);
  const ar = {
    new: "جاري مراجعة الطلب",
    preparing: "يتم تجهيز الطلب",
    shipped: "تم ارسال الطلب من المتجر",
    delivered: "تم ايصال الطلب للعميل",
    cancelled: "ملغي",
  };
  const en = {
    new: "Order under review",
    preparing: "Order being prepared",
    shipped: "Order sent from store",
    delivered: "Delivered to customer",
    cancelled: "Cancelled",
  };
  const map = lang === "en" ? en : ar;
  return map[k] || String(st || "—");
}

/** قيم الحالة المخزّنة في الـ API */
export const ORDER_STATUS_VALUES = ["new", "preparing", "shipped", "delivered"];

/** هل يُسمح بتعديل بيانات الطلب والأسطر (قبل التأكيد فقط)؟ */
export function orderAllowsItemEdit(st) {
  return normalizeOrderStatus(st) === "new";
}

/** هل يُسمح لصاحب المتجر بتعديل الطلب أو إلغائه؟ (كل الحالات ما عدا الملغي) */
export function orderAllowsOwnerEdit(st) {
  return !orderIsCancelled(st);
}

/** طلب مُرسل لتاجر جملة وأكّده — التعديل/الإلغاء من تاجر الجملة فقط */
export function orderLockedByWholesalerConfirmation(order) {
  return Boolean(order?.wholesale_forward_confirmed);
}

/** هل يستطيع صاحب المتجر تعديل أو إلغاء الطلب؟ */
export function retailOrderAllowsOwnerEdit(order) {
  if (!order) return false;
  if (!orderAllowsOwnerEdit(order.status)) return false;
  if (orderLockedByWholesalerConfirmation(order)) return false;
  return true;
}

/** هل الطلب ما زال في مرحلة المراجعة (قبل خصم المخزون)؟ */
export function orderIsReviewing(st) {
  return normalizeOrderStatus(st) === "new";
}

/** يُحسب ضمن المبيعات المؤكدة */
export function orderCountsAsSale(st) {
  const k = normalizeOrderStatus(st);
  return k === "preparing" || k === "shipped" || k === "delivered";
}

/** تاريخ إسناد المبيعة — يوم التأكيد الأول (لا يتغير عند التعديل لاحقاً). */
export function orderSalesAttributionAt(o) {
  if (!o || !orderCountsAsSale(o.status)) return null;
  const at = o?.confirmed_at || o?.updated_at || o?.created_at;
  return at || null;
}

/** مفتاح اليوم YYYY-MM-DD لإسناد المبيعة. */
export function orderSalesDayKey(o) {
  const at = String(orderSalesAttributionAt(o) || "");
  if (!at) return "";
  return at.includes("T") ? at.split("T")[0] : at.slice(0, 10);
}

/** هل المبيعة المؤكدة تُنسب لليوم الحالي (توقيت المتصفح)؟ */
export function isOrderSalesToday(o) {
  const at = orderSalesAttributionAt(o);
  if (!at) return false;
  const d = new Date(at);
  if (String(d) === "Invalid Date") return false;
  return d.toDateString() === new Date().toDateString();
}
